export function MobileAnnouncement() {
  return (
    <div className="mobile-announce" role="note">
      <span className="mobile-announce__pill">Coming soon</span>
      <span className="mobile-announce__text">
        <strong>iOS &amp; Android apps</strong> — beta release on <strong>15 June 2026</strong>. Get push notifications the second a recruiter opens your CV.
      </span>
    </div>
  );
}
